
const Mutation = {
  "name": "Mutation",
  "kind": "OBJECT",
  "fieldBaseTypes": {
    "cartAttributesUpdate": "CartAttributesUpdatePayload",
    "cartBuyerIdentityUpdate": "CartBuyerIdentityUpdatePayload",
    "cartCreate": "CartCreatePayload",
    "cartDiscountCodesUpdate": "CartDiscountCodesUpdatePayload",
    "cartLinesAdd": "CartLinesAddPayload",
    "cartLinesRemove": "CartLinesRemovePayload",
    "cartLinesUpdate": "CartLinesUpdatePayload",
    "cartMetafieldDelete": "CartMetafieldDeletePayload",
    "cartMetafieldsSet": "CartMetafieldsSetPayload",
    "cartNoteUpdate": "CartNoteUpdatePayload",
    "cartPaymentUpdate": "CartPaymentUpdatePayload",
    "cartSelectedDeliveryOptionsUpdate": "CartSelectedDeliveryOptionsUpdatePayload",
    "cartSubmitForCompletion": "CartSubmitForCompletionPayload",
    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
    "checkoutCompleteFree": "CheckoutCompleteFreePayload",
    "checkoutCompleteWithCreditCardV2": "CheckoutCompleteWithCreditCardV2Payload",
    "checkoutCompleteWithTokenizedPaymentV3": "CheckoutCompleteWithTokenizedPaymentV3Payload",
    "checkoutCreate": "CheckoutCreatePayload",
    "checkoutCustomerAssociateV2": "CheckoutCustomerAssociateV2Payload",
    "checkoutCustomerDisassociateV2": "CheckoutCustomerDisassociateV2Payload",
    "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
    "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
    "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
    "checkoutGiftCardRemoveV2": "CheckoutGiftCardRemoveV2Payload",
    "checkoutGiftCardsAppend": "CheckoutGiftCardsAppendPayload",
    "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
    "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
    "checkoutLineItemsReplace": "CheckoutLineItemsReplacePayload",
    "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload",
    "checkoutShippingAddressUpdateV2": "CheckoutShippingAddressUpdateV2Payload",
    "checkoutShippingLineUpdate": "CheckoutShippingLineUpdatePayload",
    "customerAccessTokenCreate": "CustomerAccessTokenCreatePayload",
    "customerAccessTokenCreateWithMultipass": "CustomerAccessTokenCreateWithMultipassPayload",
    "customerAccessTokenDelete": "CustomerAccessTokenDeletePayload",
    "customerAccessTokenRenew": "CustomerAccessTokenRenewPayload",
    "customerActivate": "CustomerActivatePayload",
    "customerActivateByUrl": "CustomerActivateByUrlPayload",
    "customerAddressCreate": "CustomerAddressCreatePayload",
    "customerAddressDelete": "CustomerAddressDeletePayload",
    "customerAddressUpdate": "CustomerAddressUpdatePayload",
    "customerCreate": "CustomerCreatePayload",
    "customerDefaultAddressUpdate": "CustomerDefaultAddressUpdatePayload",
    "customerRecover": "CustomerRecoverPayload",
    "customerReset": "CustomerResetPayload",
    "customerResetByUrl": "CustomerResetByUrlPayload",
    "customerUpdate": "CustomerUpdatePayload"
  },
  "implementsNode": false,
  "relayInputObjectBaseTypes": {
    "cartCreate": "CartInput",
    "cartMetafieldDelete": "CartMetafieldDeleteInput",
    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
    "checkoutCreate": "CheckoutCreateInput",
    "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
    "customerActivate": "CustomerActivateInput",
    "customerCreate": "CustomerCreateInput",
    "customerReset": "CustomerResetInput"
  }
};
export default Mutation;